import React from 'react';
import Title from './shared/Title';

const GallerieS = () => {
  const images = () => {
    let imageList = [];

    for (let i = 1; i < 9; i++) {
      imageList[i - 1] = {
        id: i, 
        img: require(`../assets/self/gallery/${i}.jpg`), 
        alt: `Technique de self-défense ${i}`,
        title: `Technique ${i}`
      };
    }

    return imageList;
  };

  return (
    <section className="relative py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-primary/10 to-red-600/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-red-600/5 to-primary/10 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
            Galerie photos
          </div>
          <Title 
            title="Self-Défense" 
            className="text-white mb-6"
          />
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-4">
            Développer une boîte à outils de techniques réalistes et utiles
          </p>
          {/* <p className="text-gray-400 max-w-2xl mx-auto">
            Quelques photos
          </p> */}
        </div>

        {/* Galerie simple et épurée - Optimisée mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 mb-16">
          {images().map((element, index) => (
            <div 
              key={element.id} 
              className="relative overflow-hidden rounded-xl sm:rounded-2xl aspect-square hover:scale-105 transition-transform duration-300"
            >
              <img
                alt={element.alt}
                className="w-full h-full object-cover object-top"
                src={element.img}
              />
              {/* Overlay subtil au hover sur desktop */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 hidden sm:block"></div>
            </div>
          ))}
        </div>

        {/* Section informations sur la self-défense */}
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-3xl shadow-xl p-6 md:p-8 border border-gray-700">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4">Pourquoi la self-défense ?</h3>
            {/* <p className="text-gray-300">Les avantages d'une formation en self-défense avec ECKSD</p> */}
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">Protection</h4>
              <p className="text-gray-300 text-xs md:text-sm">
                Apprenez à vous défendre efficacement dans des situations réelles.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">Confiance</h4>
              <p className="text-gray-300 text-xs md:text-sm">
                Développez votre assurance et votre capacité à gérer le stress.
              </p>
            </div>
            
            <div className="text-center col-span-2 md:col-span-1">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">Technique</h4>
              <p className="text-gray-300 text-xs md:text-sm">
                Maîtrisez des techniques simples mais redoutablement efficaces.
              </p>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary to-red-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Prêt à apprendre la self-défense ?</h3>
            <p className="text-gray-100 mb-6 max-w-2xl mx-auto">
              Rejoignez nos cours de self-défense et développez vos réflexes de protection dans un environnement sécurisé.
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-white text-primary font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <span>Essayer un cours</span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerieS